import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";
import Circle from "../../models/circle";

export default class CirclesNewRoute extends DiscourseRoute {
  @service circles;
  @service store;

  showFooter = true;

  titleToken() {
    return i18n("discourse_circles.new.title_token");
  }

  async beforeModel() {
    await this.circles.reloadCustomFields();
  }

  async model() {
    return this.store.createRecord("circle", Circle.attributesDefaults());
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.set("model", model);
  }
}
